module.exports = __webpack_public_path__ + "img/screenshot-chocaho.cdc3392c.png";